import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

export interface IRadioButtonGroupUIStateProps {
    itemArray: string[];
    name: string;
    cardId?: string;
    selectedItem?: any;
}

export interface IRadioButtonGroupUIDispatchProps {
    onChange?: { (value: string) };
}

export interface IRadioButtonGroupUIProps extends IRadioButtonGroupUIStateProps, IRadioButtonGroupUIDispatchProps {
}

export interface IRadioButtonGroupUIState {
}

export default class RadioButtonGroupUI extends Component<IRadioButtonGroupUIProps, IRadioButtonGroupUIState> {
    static propTypes = {
        itemArray: PropTypes.array,
        name: PropTypes.string,
        cardId: PropTypes.string,
        selectedItem: PropTypes.string
    };

    handleClick(value: string) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    buildRadioButtonGroup(itemArray, name, selectedItem) {
        return itemArray.map((item, index) => {
            const unlimitedMiles = item === 'Unlimited' ? 'unlimited-miles' : '';
            let checked = '';
            if ((selectedItem !== null) && (selectedItem === item)) {
                checked = 'checked';
            }

            return (
                <div className={`radio-button ${checked} ${unlimitedMiles}`}
                     onClick={() => { this.handleClick(item); } }
                     key={`${this.props.cardId}-${name}-${index}`}>
                    <input
                        type="radio" id={`${this.props.cardId}-${name}-${index}`}
                        name={`${this.props.cardId}-${name}`} value={item}
                    />
                    <label
                        htmlFor={`${this.props.cardId}-${name}-${index}`}>
                        {item}
                    </label>
                </div>
            );
        });
    }

    render() {
        const {
            itemArray,
            name,
            selectedItem
        } = this.props;

        const getRadioButtonGroup = this.buildRadioButtonGroup(itemArray, name, selectedItem);

        return (
            <div className="radio-button-group">
                { getRadioButtonGroup }
            </div>
        );
    }
}
